import PropTypes from 'prop-types';

export const notificationPropType = {
  id: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  icon: PropTypes.string,
  image: PropTypes.element,
  isRead: PropTypes.bool,
  linkedContent: PropTypes.shape({
    contentType: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired
  }),
  metadata: PropTypes.shape({
    action: PropTypes.string,
    actors: PropTypes.arrayOf(PropTypes.string),
    entity: PropTypes.shape({
      entityType: PropTypes.string,
      entityId: PropTypes.string,
      title: PropTypes.string,
      startTime: PropTypes.string,
      status: PropTypes.string,
      recipientStatus: PropTypes.string,
      hasConflict: PropTypes.bool,
      canAccept: PropTypes.bool,
      canDecline: PropTypes.bool
    })
  }),
  publishedAt: PropTypes.instanceOf(Date)
};
